import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import shouye from "../mobile/index.vue";
import home from "../pc/index.vue";


//使用模块化机制编程，导入 Vue 和 VueRouter，要调用 Vue.use(VueRouter)
Vue.use(VueRouter);

const routes = [{
		path: "/shouye",
		component: shouye
	},
	{
		path: "/shouye/:channel",
		component: shouye
	},
	{
		path: "/home",
		component: home
	},
	{
		path: "/home/:channel",
		component: home
	},
	{
		path: '*',
		meta: {
			title: '皇冠'
		},
		redirect: '/home'
	}
]
//创建路由管理器
var router = new VueRouter({
	mode: 'history',
	routes //es6缩写,等于routes:routes
})
export default router;
